import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Caption, Sheet, Tag } from "../../components/ui/ds";
import { BuzerIcon } from "../../BuzerIcons";
import { st } from "../../styles.js";
import "./tips-sheet.css";

// Zoznam VŠETKÝCH tipov — otvára sa ťuknutím na banner „Tip dňa" na Dnes.
// Tip dňa ukazuje jeden tip denne a každý najviac raz za kolo (tips_daily.tip_for_user),
// takže bez tohto zoznamu sa k už videnému tipu nedalo vrátiť a k tomu neznámemu dostať skôr.
// Dáta chodia z `GET /api/tips` až pri otvorení — do polleného /api/state nepatria
// (31 viet pri každom polle by bola zbytočná záťaž).
export function TipsSheet({ onClose }) {
  const [data, setData] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => {
    api("/api/tips").then(setData).catch((e) => setErr(e.message));
  }, []);
  const items = (data && data.items) || [];
  return (
    <Sheet title="Všetky tipy" icon="bulb" onClose={onClose}>
      {!data && !err && <div style={{ display: "flex", justifyContent: "center", padding: 24 }}><div className="spin" /></div>}
      {err && <div style={st.err}>{err}</div>}
      {data && (
        <>
          <Caption>Prečítané {data.seen_count} z {items.length}. Nový tip dostaneš každý deň — ten istý ti appka druhýkrát neukáže.</Caption>
          <ol className="bz-tips">
            {items.map((t) => (
              <li key={t.key} className={"bz-tips__item" + (t.seen ? "" : " bz-tips__item--new")}>
                <span className="bz-tips__mark">
                  <BuzerIcon name={t.seen ? "check" : "bulb"} size={15} color="currentColor" />
                </span>
                <span className="bz-tips__text">
                  {t.text}
                  {t.today && <> <Tag tone="brand" size="xs">dnešný</Tag></>}
                </span>
              </li>
            ))}
          </ol>
        </>
      )}
    </Sheet>
  );
}
